import Vue from 'vue';
import { Setting, Request } from '../../index';

// 小程序日志
const log = require('./log.js');

//
const init = () => {
  // 多语言初始化
  if (wx) {
    try {
      const res = wx.getSystemInfoSync();
      Setting.setLanguage(res.language);
    } catch (e) {
      console.log('[language-init] wx err', e);
    }
  }
  // 错误统一处理
  let lastAlertErr = null; // 防止重复处理同一错误
  Setting.errorHandler = (err, vm, info) => {
    if (vm) {
      console.log(`%c Error Info: ${info}`, 'color:#f33;', err, Setting.app);
    }
    // 错误处理
    if (err !== lastAlertErr) {
      // 错误通知
      if (uni && uni.showModal) {
        // 标记错误已处理
        lastAlertErr = err;
        // 错误拦截
        if (Request.doErrorFilter(err)) {
          // 错误已被自定义拦截
          console.log('[err-ignore]', err);
        } else {
          // 标准弹窗错误
          if (uni.hideLoading) {
            uni.hideLoading(); // 弹窗前先取消遮挡
          }
          // 标准错误解析
          const info = Request.getErrorMsg(err);
          if (Request.isCodeNetworkError(info.code)) {
            // 这是一个网络错误
            uni.showToast({
              title: '网络不给力',
              icon: 'none',
              duration: 2000,
            });
          } else if (Request.isCodeTokenError(info.code)) {
            // token错误只打印日志
            console.warn(`[token-err] ${info.title} ${info.message}`);
          } else {
            // 其它错误弹窗显示
            uni.showModal({
              title: info.title,
              content: info.message,
              showCancel: false,
            });
            // 同时记录到微信平台
            log.error(err);
          }
        }
      }
    }
  };
  // token错误:跳转到登录页
  Setting.errorHandlerToken = err => {
    err = Request.getErrorMsg(err);
    console.log('[debug-app]', Setting.app);
    if (Setting.app && Setting.app.$store) {
      // 清除token
      Setting.app.$store.dispatch('user/clean');
      // 处理登录初始化
      if (Setting.loginUrl) {
        console.log('[token错误捕捉] 需要跳转到登录页', err, Setting.loginUrl);
        window.location = Setting.loginUrl;
      } else {
        console.log('[token错误捕捉] 需要跳转到登录页', err);
        // 删除回调地址
        Request.delValue(Setting.getStoreUrl());
      }
      // 继续将错误抛出
      throw err;
    } else {
      console.log('[token错误捕捉]', err);
    }
  };
  // hook绑定
  const ht = async token => {
    if (token) {
      console.log(`[init-user] 用户登录成功 ${token.uid}`);
      log.info(`[init-user] 用户登录成功 ${token.uid}`);
      // 自动初始化
      if (Setting.app && Setting.app.$store && Setting.app.$store.state) {
        // cms模块
        if (Setting.app.$store.state.cms) {
          Setting.app.$store
            .dispatch('cms/cmsUser')
            .then(cmsUser => {
              if (cmsUser) {
                console.log('[init-cms] 文章模块自动初始化成功', cmsUser);
                log.info('[init-cms] 文章模块自动初始化成功', cmsUser);
              } else {
                console.error('[init-cms] 文章模块自动初始化失败');
                log.error('[init-cms] 文章模块自动初始化失败');
              }
            })
            .catch(err => {
              console.error('[init-cms] 文章模块自动初始化失败', err);
              log.error('[init-cms] 文章模块自动初始化失败', err);
            });
        }
        // wallet模块
        if (Setting.app.$store.state.wallet) {
          Setting.app.$store
            .dispatch('wallet/walletUser')
            .then(async walletUser => {
              if (walletUser) {
                const walletList = await Setting.app.$store.dispatch('wallet/walletList');
                console.log('[init-wallet] 钱包模块自动初始化成功', walletUser, walletList);
                log.info('[init-wallet] 钱包模块自动初始化成功', walletUser, walletList);
              } else {
                console.error('[init-wallet] 钱包模块自动初始化失败');
                log.error('[init-wallet] 钱包模块自动初始化失败');
              }
            })
            .catch(err => {
              console.error('[init-wallet] 钱包模块自动初始化失败', err);
              log.error('[init-wallet] 钱包模块自动初始化失败', err);
            });
        }
        // mall模块
        if (Setting.app.$store.state.mall) {
          Setting.app.$store
            .dispatch('mall/mallUser')
            .then(mallUser => {
              if (mallUser) {
                console.log('[init-mall] 商城模块自动初始化成功', mallUser);
                log.info('[init-mall] 商城模块自动初始化成功', mallUser);
              } else {
                console.error('[init-mall] 商城模块自动初始化失败');
                log.error('[init-mall] 商城模块自动初始化失败');
              }
            })
            .catch(err => {
              console.error('[init-mall] 商城模块自动初始化失败', err);
              log.error('[init-mall] 商城模块自动初始化失败', err);
            });
        }
        // msg模块
        if (Setting.app.$store.state.msg) {
          Setting.app.$store
            .dispatch('msg/msgUser')
            .then(msgUser => {
              if (msgUser) {
                console.log('[init-msg] 消息模块自动初始化成功', msgUser);
                log.info('[init-msg] 消息模块自动初始化成功', msgUser);
              } else {
                console.error('[init-msg] 消息模块自动初始化失败');
                log.error('[init-msg] 消息模块自动初始化失败');
              }
            })
            .catch(err => {
              console.error('[init-msg] 消息模块自动初始化失败', err);
              log.error('[init-msg] 消息模块自动初始化失败', err);
            });
        }
      }
    } else {
      console.log('用户登录失败');
      log.error('用户登录失败');
    }
  };
  Setting.addInitialHandlerToken(ht, true);
  // vue初始化
  Vue.config.productionTip = false;
  Vue.config.errorHandler = Setting.errorHandler;
};

//
export default {
  init,
};
